export default "__VITE_ASSET__BwCZo7oS__"